var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var parcelRequire = $parcel$global["parcelRequirec887_xs5e3"];
parcelRequire.register("i8HwC", function(module, exports) {
function $d34abc8819e87aab$var$e(e, t, n, s) {
    Object.defineProperty(e, t, {
        get: n,
        set: s,
        enumerable: !0,
        configurable: !0
    });
}
var $d34abc8819e87aab$var$t = ("undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : {}).parcelRequire3a38_xcfmk, $d34abc8819e87aab$var$n = $d34abc8819e87aab$var$t.register;

$d34abc8819e87aab$var$n("8mF5Z", function(n, s) {
    $d34abc8819e87aab$var$e(n.exports, "RistrettoPlayerWrapper", function() {
        return h;
    });
    var i = $d34abc8819e87aab$var$t("bsvQL"), r = $d34abc8819e87aab$var$t("hJ7nZ"), a = $d34abc8819e87aab$var$t("4gxuw"), o = $d34abc8819e87aab$var$t("giOKx");
    let l = {
        framesDecoded: {
            originalPath: "inbound-rtp:video.framesDecoded",
            modifier: "raw",
            reducer: "sum",
            filter: "number"
        },
        nackCount: {
            originalPath: "inbound-rtp:video.nackCount",
            modifier: "raw",
            reducer: "sum",
            filter: "number"
        },
        totalFreezesDuration: {
            originalPath: "inbound-rtp:video.totalFreezesDuration",
            modifier: "raw",
            reducer: "sum",
            filter: "number"
        },
        totalPausesDuration: {
            originalPath: "inbound-rtp:video.totalPausesDuration",
            modifier: "raw",
            reducer: "sum",
            filter: "number"
        },
        fecPacketsReceived: {
            originalPath: "inbound-rtp.fecPacketsReceived",
            modifier: "raw",
            reducer: "sum",
            filter: "number"
        },
        fecPacketsDiscarded: {
            originalPath: "inbound-rtp.fecPacketsDiscarded",
            modifier: "raw",
            reducer: "sum",
            filter: "number"
        },
        framesReceived: {
            originalPath: "inbound-rtp:video.framesReceived",
            modifier: "raw",
            reducer: "sum",
            filter: "number"
        },
        packetsLost: {
            originalPath: "inbound-rtp.packetsLost",
            modifier: "raw",
            reducer: "sum",
            filter: "number"
        },
        packetsDiscarded: {
            originalPath: "inbound-rtp.packetsDiscarded",
            modifier: "raw",
            reducer: "sum",
            filter: "number"
        },
        packetsReceived: {
            originalPath: "inbound-rtp.packetsReceived",
            modifier: "raw",
            reducer: "sum",
            filter: "number"
        },
        totalRoundTripTime: {
            originalPath: "candidate-pair.totalRoundTripTime",
            modifier: "raw",
            reducer: "sum",
            filter: "nonzero"
        },
        responsesReceived: {
            originalPath: "candidate-pair.responsesReceived",
            modifier: "raw",
            reducer: "sum",
            filter: "nonzero"
        },
        audioJitter: {
            originalPath: "inbound-rtp:audio.jitter",
            modifier: "raw",
            reducer: "sum",
            filter: "number"
        },
        videoJitter: {
            originalPath: "inbound-rtp:video.jitter",
            modifier: "raw",
            reducer: "sum",
            filter: "number"
        }
    }, c = Object.keys(l);
    class h extends a.AbstractWrapper {
        constructor(e, t = {}){
            super(e, t), this._ristrettoModuleCache = null, this._abrResolutions = [], this._isABREnabled = !1, this._isLoadingPlayerModule = !1, this._logLevels = [], this._ristrettoPlaybackStateToMMPStateMap = null, this._toggleTurnServersListener = e.subscribe(o.EPlayersEvents.TOGGLE_TURN_SERVERS, this._toggleTURNServers);
        }
        destroy() {
            return this._eventBusInstance.unsubscribe(this._toggleTurnServersListener), super.destroy();
        }
        setStreamConfig(e) {
            return e?.WebRTCSignallingUrl ? (this._lastKnownStreamConfig = {
                WebRTCStreamId: e.WebRTCStreamId,
                WebRTCACLToken: e?.WebRTCACLToken,
                WebRTCSignallingUrl: e?.WebRTCSignallingUrl
            }, this._setStreamConfig()) : this._lastKnownStreamConfig = null, this;
        }
        enableAbr() {
            return this._isABREnabled = !0, this._playerInstance?.enableABR(), this;
        }
        disableAbr() {
            return this._isABREnabled = !1, this._playerInstance?.disableABR(), this;
        }
        setAbrResolutions(e) {
            return this._abrResolutions = e, this._playerInstance?.setAbrResolutionsVariants(e), this;
        }
        setLoggerLevel(e) {
            this._playerInstance?.setLoggerLevels(e), this._logLevels = e;
        }
        setResolutionByName(e) {
            return this._playerInstance?.setQualityByName(e), this;
        }
        setResolutionByBitrate(e) {
            return this._playerInstance?.setQualityByBitrate(e), this;
        }
        async recreatePlayerInstance() {
            this._playerInstance && !this._persistent && (this.destroy(), this._playerInstance = null), await this._createPlayerInstance();
        }
        setPlayerConfig(e) {
            return this._lastKnownConfig = e, this._lastKnownConfig.peerConnectionConfig || (this._lastKnownConfig.peerConnectionConfig = {}), this._lastKnownConfig.peerConnectionConfig?.statsCollectionScheme ? this._lastKnownConfig.peerConnectionConfig.statsCollectionScheme = {
                ...this._lastKnownConfig.peerConnectionConfig.statsCollectionScheme,
                ...l
            } : this._lastKnownConfig.peerConnectionConfig.statsCollectionScheme = l, this._playerInstance?.setConfig(e, !0), this;
        }
        setResolutionLimits() {
            return this;
        }
        get version() {
            return this._playerInstance?.version;
        }
        _attachEventListeners() {
            this._ristrettoModuleCache && this._playerInstance && (this._playerInstance.addEventListener(this._ristrettoModuleCache.ECommonEvents.DEBUGGER_CONNECTED, this._onDebuggerConnected), this._playerInstance.addEventListener(this._ristrettoModuleCache.EPlayerEvent.PLAY_STATE_CHANGED, this._onPlaybackStateChanged), this._playerInstance.addEventListener(this._ristrettoModuleCache.ECommonEvents.ERROR, this._onRistrettoError), this._playerInstance.addEventListener(this._ristrettoModuleCache.ECommonEvents.PEER_METRICS_AVAILABLE, this._onPeerMetricsAvailable), this._playerInstance.addEventListener(this._ristrettoModuleCache.ECommonEvents.LIFECYCLE_EVENT, this._onLifecycleEventReported), this._playerInstance.addEventListener(this._ristrettoModuleCache.ECommonEvents.LIFECYCLE_ERROR, this._onLifecycleErrorReported), this._playerInstance.addEventListener(this._ristrettoModuleCache.ECommonEvents.RESOLUTION_SWITCH_AUTO, this._onRenditionSwitchAuto), this._playerInstance.addEventListener(this._ristrettoModuleCache.ECommonEvents.RESOLUTIONS_AVAILABLE, this._onResolutionsAvailable), this._playerInstance.addEventListener(this._ristrettoModuleCache.ECommonEvents.QUALITY_CHANGED, this._onQualityChanged), this._playerInstance.addEventListener(this._ristrettoModuleCache.ECommonEvents.LATENCY_ESTIMATION_AVAILABLE, this._onLatencyEstimationAvailable));
        }
        _detachEventListeners() {
            this._ristrettoModuleCache && this._playerInstance && (this._playerInstance.removeEventListener(this._ristrettoModuleCache.ECommonEvents.DEBUGGER_CONNECTED, this._onDebuggerConnected), this._playerInstance.removeEventListener(this._ristrettoModuleCache.EPlayerEvent.PLAY_STATE_CHANGED, this._onPlaybackStateChanged), this._playerInstance.removeEventListener(this._ristrettoModuleCache.ECommonEvents.ERROR, this._onRistrettoError), this._playerInstance.removeEventListener(this._ristrettoModuleCache.ECommonEvents.PEER_METRICS_AVAILABLE, this._onPeerMetricsAvailable), this._playerInstance.removeEventListener(this._ristrettoModuleCache.ECommonEvents.RESOLUTION_SWITCH_AUTO, this._onRenditionSwitchAuto), this._playerInstance.removeEventListener(this._ristrettoModuleCache.ECommonEvents.RESOLUTIONS_AVAILABLE, this._onResolutionsAvailable), this._playerInstance.removeEventListener(this._ristrettoModuleCache.ECommonEvents.QUALITY_CHANGED, this._onQualityChanged), this._playerInstance.removeEventListener(this._ristrettoModuleCache.ECommonEvents.LATENCY_ESTIMATION_AVAILABLE, this._onLatencyEstimationAvailable));
        }
        async _createPlayerInstance() {
            if (!this._ristrettoModuleCache) return void this._loadRistrettoModule();
            this._persistent && this._playerInstance || (this._destroyPlayerInstance(), this._playerInstance = new this._ristrettoModuleCache.Player), this._lastKnownConfig && this._playerInstance.setConfig(this._lastKnownConfig, !0), this._playerInstance?.setConfig({
                peerConnectionConfig: {
                    statsCollectionScheme: l,
                    statsGatheringPeriod: 500
                }
            }), this._setStreamConfig(), this._playerInstance.setAppKey(this._appKey), this._videoElement && this._playerInstance.setVideoElement(this._videoElement), this._attachEventListeners(), this._playerInstance?.setAppKey("callbackApp"), this._isStarted && this._playerInstance?.start(), this._isABREnabled ? this._playerInstance?.enableABR() : this._playerInstance?.disableABR(), this._playerInstance?.setAbrResolutionsVariants(this._abrResolutions), this._playerInstance?.setLoggerLevels(this._logLevels);
        }
        _setStreamConfig() {
            this._playerInstance && this._lastKnownStreamConfig && this._playerInstance?.setStreamConfig({
                aclToken: this._lastKnownStreamConfig.WebRTCACLToken,
                streamId: this._lastKnownStreamConfig.WebRTCStreamId,
                wsUrl: this._lastKnownStreamConfig.WebRTCSignallingUrl
            }, !0);
        }
        async _loadRistrettoModule() {
            if (this._isLoadingPlayerModule) return;
            this._isLoadingPlayerModule = !0;
            let { EStreamStatus: e , Player: n , ECommonEvents: s , EPlayerEvent: i  } = await $d34abc8819e87aab$var$t("h9Af4");
            this._ristrettoModuleCache = {
                EStreamStatus: e,
                Player: n,
                ECommonEvents: s,
                EPlayerEvent: i
            }, this._ristrettoPlaybackStateToMMPStateMap = {
                [e.UNKNOWN]: r.EPlaybackState.IDLE,
                [e.CONNECTING]: r.EPlaybackState.LOADING,
                [e.LIVE]: r.EPlaybackState.PLAYING,
                [e.FINISHED]: r.EPlaybackState.PAUSED,
                [e.ERRORED]: r.EPlaybackState.ERROR
            }, this._isLoadingPlayerModule = !1, this._createPlayerInstance();
        }
        _onDebuggerConnected({ detail: { debuggerUrl: e  }  }) {
            this._eventBusInstance.publish(o.EPlayersEvents.DEBUGGER_CONNECTED, {
                debuggerUrl: e
            });
        }
        _onPlaybackStateChanged({ detail: { prevState: e , nextState: t  }  }) {
            this._ristrettoPlaybackStateToMMPStateMap && this._eventBusInstance.publish(o.EPlayersEvents.PLAYBACK_STATE_CHANGED, {
                nextState: this._ristrettoPlaybackStateToMMPStateMap[t],
                prevState: this._ristrettoPlaybackStateToMMPStateMap[e]
            });
        }
        _onRistrettoError({ detail: e  }) {
            this._eventBusInstance.publish(o.EPlayersEvents.ERROR, {
                error: Error(`Ristretto player error: ${e.info}`),
                isFatal: e.isFatal,
                playerType: r.EPlayerType.WEBRTC
            });
        }
        _onPeerMetricsAvailable({ detail: { metrics: e  }  }) {
            let t = c.reduce((t, n)=>(Object.hasOwn(e, n) && (t[n] = e[n]), t), {});
            this._metricsCollector?.registerMetrics(t);
        }
        _onLifecycleEventReported({ detail: { eventType: e  }  }) {
            this._metricsCollector?.registerEvent(e);
        }
        _onLifecycleErrorReported({ detail: { errorType: e , nativeError: t  }  }) {
            this._metricsCollector?.registerEvent(e, {
                errorMessage: t?.message || ""
            });
        }
        _onResolutionsAvailable({ detail: { resolutions: e  }  }) {
            this._eventBusInstance.publish(o.EPlayersEvents.RESOLUTIONS_AVAILABLE, {
                resolutions: e
            });
        }
        _onRenditionSwitchAuto({ detail: { prevResolution: e , nextResolution: t  }  }) {
            this._metricsCollector?.registerEvent("RenditionSwitchedAuto", {
                prevResolution: e,
                nextResolution: t
            }), this._eventBusInstance.publish(o.EPlayersEvents.AUTO_RESOLUTION_SWITCHED, {
                name: t
            });
        }
        _toggleTURNServers({ shouldUseTURNServers: e  }) {
            this._playerInstance?.toggleTURNServersUsage(e);
        }
        _onQualityChanged({ detail: { name: e  }  }) {
            this._eventBusInstance.publish(o.EPlayersEvents.RESOLUTION_SWITCHED, {
                name: e
            });
        }
        _onLatencyEstimationAvailable({ detail: { latencyEstimationEWMA: e , latencyEstimationMedian: t  }  }) {
            this._eventBusInstance.publish(o.EPlayersEvents.LATENCY_ESTIMATION_AVAILABLE, {
                medianLatency: t,
                EWMALatency: e
            });
        }
    }
    (0, i.__decorate)([
        r.bind
    ], h.prototype, "_onDebuggerConnected", null), (0, i.__decorate)([
        r.bind
    ], h.prototype, "_onPlaybackStateChanged", null), (0, i.__decorate)([
        r.bind
    ], h.prototype, "_onRistrettoError", null), (0, i.__decorate)([
        r.bind
    ], h.prototype, "_onPeerMetricsAvailable", null), (0, i.__decorate)([
        r.bind
    ], h.prototype, "_onLifecycleEventReported", null), (0, i.__decorate)([
        r.bind
    ], h.prototype, "_onLifecycleErrorReported", null), (0, i.__decorate)([
        r.bind
    ], h.prototype, "_onResolutionsAvailable", null), (0, i.__decorate)([
        r.bind
    ], h.prototype, "_onRenditionSwitchAuto", null), (0, i.__decorate)([
        r.bind
    ], h.prototype, "_toggleTURNServers", null), (0, i.__decorate)([
        r.bind
    ], h.prototype, "_onQualityChanged", null), (0, i.__decorate)([
        r.bind
    ], h.prototype, "_onLatencyEstimationAvailable", null);
}), $d34abc8819e87aab$var$n("4gxuw", function(n, s) {
    $d34abc8819e87aab$var$e(n.exports, "AbstractWrapper", function() {
        return o;
    });
    var i = $d34abc8819e87aab$var$t("bsvQL"), r = $d34abc8819e87aab$var$t("hJ7nZ"), a = $d34abc8819e87aab$var$t("giOKx");
    class o {
        constructor(e, t = {}){
            this._videoElement = null, this._lastKnownConfig = {}, this._lastKnownStreamConfig = null, this._playerInstance = null, this._metricsCollector = null, this._eventBusInstance = e, this._eventBusInstance.publish(a.EPlayersEvents.MODULE_LOADED, {}), this._persistent = !!t.persistent;
        }
        setMetricsCollector(e) {
            this._metricsCollector = e;
        }
        destroy() {
            return this._destroyPlayerInstance(), this._isStarted = !1, this;
        }
        setAppKey(e) {
            return this._appKey = e, this;
        }
        setVideoElement(e) {
            return this._videoElement = e, e && this._playerInstance?.setVideoElement(e), this;
        }
        async recreatePlayerInstance() {
            this._playerInstance && (this.destroy(), this._playerInstance = null), await this._createPlayerInstance();
        }
        start() {
            return this._playerInstance || this.recreatePlayerInstance(), this._playerInstance?.start(), this._isStarted = !0, this;
        }
        stop() {
            return this._isStarted = !1, this._persistent && this._playerInstance && "stop" in this._playerInstance ? this._playerInstance.stop() : this._destroyPlayerInstance(), this;
        }
        setPlayerConfig(e) {
            return this._lastKnownConfig = e, this._playerInstance?.setConfig(e, !0), this;
        }
        _destroyPlayerInstance() {
            this._playerInstance && (this._detachEventListeners(), this._playerInstance.destroy(), this._playerInstance = null);
        }
    }
    (0, i.__decorate)([
        r.AsyncGuarderDecorator
    ], o.prototype, "recreatePlayerInstance", null);
}), $d34abc8819e87aab$var$n("h9Af4", function(e, n) {
    e.exports = (parcelRequire("exmZj")).then(()=>$d34abc8819e87aab$var$t("2vSYt"));
});

});
parcelRequire.register("exmZj", function(module, exports) {
module.exports = Promise.resolve(require("./module.0589a59c.aee73ec2.js")).then(()=>parcelRequire("eobC3"));

});



//# sourceMappingURL=RistrettoPlaying.543cbcb1.4f049080.js.map
